import { NavigateFunction, useNavigate } from 'react-router-dom'
import { styled } from 'styled-components'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'
import { useAppContext } from '../../components/provider/AppProvider'
import { Button } from '../../components/Button'

export default function EmptyCartFragment() {
  const navigate: NavigateFunction = useNavigate()

  const { isAppView } = useAppContext()

  return (
    <NoContentWrap>
      <NoContentCotentWrap2>
        <NoContentTitle>장바구니에 상품이 없습니다.</NoContentTitle>
        {/* {isMobile ? (
          <NoContentContent>
            상품을 장바구니에 담아
            <br />
            적립금 적용가를 확인해보세요
          </NoContentContent>
        ) : (
          <NoContentContent>상품을 장바구니에 담아 적립금 적용가를 확인해보세요</NoContentContent>
        )} */}
        <NoContentBtn
          onClick={() => {
            if (isAppView) {
              RNPostMessage(AFWebLinkType.moveToLink, {
                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}`,
              })
            } else {
              navigate('/')
            }
          }}
        >
          쇼핑하러 가기
        </NoContentBtn>
      </NoContentCotentWrap2>
    </NoContentWrap>
  )
}

export const NoContentWrap = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;

  @media screen and (min-width: 768px) {
    display: flex;
    padding: 0;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
`
export const NoContentCotentWrap2 = styled.div`
  /* display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center; */
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 120px 0;
  & img {
    width: 85px;
    height: 85px;
  }
  @media screen and (min-width: 768px) {
    padding: 144px 0;
    & img {
      width: 108px;
      height: 108px;
    }
  }
`
export const NoContentTitle = styled.p`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 8px;
  @media screen and (min-width: 768px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
`
export const NoContentContent = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: var(--colGray6);
  text-align: center;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }
`
export const NoContentBtn = styled(Button)`
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  padding: 12px 35px;
  color: var(--colWhite);
  background: var(--colBlack);
  border-radius: 76px;
  line-height: 20px;
  margin-top: 20px;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    padding: 14px 40px;
    margin-top: 32px;
    cursor: pointer;
  }
`
